module.exports = __webpack_public_path__ + "static/media/1.4ae319a4.png";